import { render, staticRenderFns } from "./new-message-component.vue?vue&type=template&id=c221cfb6&"
import script from "./new-message-component.vue?vue&type=script&lang=ts&"
export * from "./new-message-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports